import styled, { keyframes } from 'styled-components';

const bounce = keyframes`
  0%, 80%, 100% {
    opacity: 0;
  }
  40% {
    opacity: 1;
  }
`;

export const LoaderPill = styled.div`
  width: 54px;
  height: 24px;
  border-radius: 999px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  margin: 4px 0;
`;

export const Dot = styled.div`
  width: 8px;
  height: 8px;
  background-color: ${({ theme }) => theme.defaultColors.lightGrey};
  border-radius: 50%;
  animation: ${bounce} 1.4s infinite ease-in-out both;

  &:nth-child(1) {
    animation-delay: -0.32s;
  }

  &:nth-child(2) {
    animation-delay: -0.16s;
  }
`;
